import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class MedpraxProxyInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Check if the request is going to Medprax
        if (!request.url.includes('medprax.co.za')) {
            return next.handle(request);
        }

        // Forward to our proxy endpoint
        const proxyRequest = request.clone({
            url: `${environment.API_URL}/api/medprax/proxy`,
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }),
            body: {
                originalUrl: request.url,
                method: request.method,
                body: request.body,
                headers: request.headers.keys().reduce((acc, key) => {
                    acc[key] = request.headers.get(key);
                    return acc;
                }, {} as { [key: string]: string | null })
            }
        });

        return next.handle(proxyRequest);
    }
} 